// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body {
    padding: 0;
    margin: 0;
    overflow: hidden;
    width: 100%;
    height: 100%;
}

.MuiDataGrid-columnHeader {
    background-color: #21252b !important;
}

.MuiDataGrid-scrollbarFiller--header {
    background-color: #21252b !important;
}

.cesium-dialog {
    z-index: 1000;
    position: absolute;
    height: 29px;
    right: 39px;
    bottom: 0px;
    color: white;
    font-size: small;
    text-shadow: 0 0 10px #000;
    line-height: 29px;
}

.nav a,
.nav a:hover {
    color: #fff;
    text-decoration: none;
    width: 100%;
}

.login a,
.login a:hover {
    color: #90caf9;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    appearance: none;
    margin: 0;
}

button:focus {
    outline: none !important;
}

.cesium-baseLayerPicker-dropDown {
    z-index: 1;
}

.custom-baseLayerPicker-dropDown {
    padding: 16px;
    background-color: rgba(38, 38, 38, 0.75);
    position: absolute;
    right: 0;
    width: 90%;
    max-width: 300px;
    overflow: auto;
    border-radius: 10px;
    z-index: 1;

    /* fallback property in case a users browser doesn't support calc() */
    max-height: 75%;
    max-height: calc(100% - 82px);
    top: 50px;
}

.cmp-ui-chat-message > * {
    max-width: 100% !important;
}

.cmp-ui-chat-message .MuiPaper-root {
    padding: 0 8px 0 8px !important;
    margin-top: 0 !important;
}

.cmp-ui-conversation-menu-item {
    position: relative;
}

.cmp-ui-conversation-menu-item-options {
    visibility: hidden;
}

.cmp-ui-conversation-menu-item:hover .cmp-ui-conversation-menu-item-options {
    visibility: visible;
}

.cmp-ui-login-routes > * {
    color: #90caf9;
    font-size: smaller;
}

button.cesium-infoBox-camera {
    display: none;
    padding: 0px;
}

.error-boundary {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    gap: 2rem;
    border: 1px solid;
    border-color: rgba(255, 255, 255, 0.12);
}

.error-boundary > * {
    font-size: 1.5rem !important;
    margin-bottom: 0 !important;
}

.error-boundary > svg {
    font-size: 2.5rem !important;
}

.cesium-infoBox {
    width: 100%;
    max-width: 400px;
}

.control-button {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    border-color: transparent;
    background-color: white;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.control-button:hover {
    box-shadow: 0 0 3px #000;
}

.control-button > .MuiSvgIcon-root {
    color: #666;
    font-size: 1.3rem;
}

.control-button:hover > .MuiSvgIcon-root {
    color: #000;
}

.control-button-dark {
    width: 28px;
    height: 28px;
    border-radius: 3px;
    border-color: transparent;
    background-color: #121212;
    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
}

.control-button-dark:hover {
    box-shadow: 0 0 3px #000;
    cursor: pointer;
}

.control-button-dark > .MuiSvgIcon-root {
    color: white;
    font-size: 1.3rem;
}

.control-button-dark:hover > .MuiSvgIcon-root {
    color: azure;
}
`, "",{"version":3,"sources":["webpack://./client/src/css/cmp.css"],"names":[],"mappings":"AAAA;;IAEI,UAAU;IACV,SAAS;IACT,gBAAgB;IAChB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,0BAA0B;IAC1B,iBAAiB;AACrB;;AAEA;;IAEI,WAAW;IACX,qBAAqB;IACrB,WAAW;AACf;;AAEA;;IAEI,cAAc;AAClB;;AAEA;;IAEI,wBAAwB;IACxB,gBAAgB;IAChB,SAAS;AACb;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,aAAa;IACb,wCAAwC;IACxC,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,UAAU;;IAEV,qEAAqE;IACrE,eAAe;IACf,6BAA6B;IAC7B,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,SAAS;IACT,iBAAiB;IACjB,uCAAuC;AAC3C;;AAEA;IACI,4BAA4B;IAC5B,2BAA2B;AAC/B;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,uBAAuB;IACvB,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,uFAAuF;IACvF,sCAAsC;IACtC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["html,\nbody {\n    padding: 0;\n    margin: 0;\n    overflow: hidden;\n    width: 100%;\n    height: 100%;\n}\n\n.MuiDataGrid-columnHeader {\n    background-color: #21252b !important;\n}\n\n.MuiDataGrid-scrollbarFiller--header {\n    background-color: #21252b !important;\n}\n\n.cesium-dialog {\n    z-index: 1000;\n    position: absolute;\n    height: 29px;\n    right: 39px;\n    bottom: 0px;\n    color: white;\n    font-size: small;\n    text-shadow: 0 0 10px #000;\n    line-height: 29px;\n}\n\n.nav a,\n.nav a:hover {\n    color: #fff;\n    text-decoration: none;\n    width: 100%;\n}\n\n.login a,\n.login a:hover {\n    color: #90caf9;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    appearance: none;\n    margin: 0;\n}\n\nbutton:focus {\n    outline: none !important;\n}\n\n.cesium-baseLayerPicker-dropDown {\n    z-index: 1;\n}\n\n.custom-baseLayerPicker-dropDown {\n    padding: 16px;\n    background-color: rgba(38, 38, 38, 0.75);\n    position: absolute;\n    right: 0;\n    width: 90%;\n    max-width: 300px;\n    overflow: auto;\n    border-radius: 10px;\n    z-index: 1;\n\n    /* fallback property in case a users browser doesn't support calc() */\n    max-height: 75%;\n    max-height: calc(100% - 82px);\n    top: 50px;\n}\n\n.cmp-ui-chat-message > * {\n    max-width: 100% !important;\n}\n\n.cmp-ui-chat-message .MuiPaper-root {\n    padding: 0 8px 0 8px !important;\n    margin-top: 0 !important;\n}\n\n.cmp-ui-conversation-menu-item {\n    position: relative;\n}\n\n.cmp-ui-conversation-menu-item-options {\n    visibility: hidden;\n}\n\n.cmp-ui-conversation-menu-item:hover .cmp-ui-conversation-menu-item-options {\n    visibility: visible;\n}\n\n.cmp-ui-login-routes > * {\n    color: #90caf9;\n    font-size: smaller;\n}\n\nbutton.cesium-infoBox-camera {\n    display: none;\n    padding: 0px;\n}\n\n.error-boundary {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: center;\n    width: 100%;\n    height: 100%;\n    gap: 2rem;\n    border: 1px solid;\n    border-color: rgba(255, 255, 255, 0.12);\n}\n\n.error-boundary > * {\n    font-size: 1.5rem !important;\n    margin-bottom: 0 !important;\n}\n\n.error-boundary > svg {\n    font-size: 2.5rem !important;\n}\n\n.cesium-infoBox {\n    width: 100%;\n    max-width: 400px;\n}\n\n.control-button {\n    width: 28px;\n    height: 28px;\n    border-radius: 3px;\n    border-color: transparent;\n    background-color: white;\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.control-button:hover {\n    box-shadow: 0 0 3px #000;\n}\n\n.control-button > .MuiSvgIcon-root {\n    color: #666;\n    font-size: 1.3rem;\n}\n\n.control-button:hover > .MuiSvgIcon-root {\n    color: #000;\n}\n\n.control-button-dark {\n    width: 28px;\n    height: 28px;\n    border-radius: 3px;\n    border-color: transparent;\n    background-color: #121212;\n    background-image: linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.05));\n    box-shadow: 0 0 3px rgba(0, 0, 0, 0.5);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.control-button-dark:hover {\n    box-shadow: 0 0 3px #000;\n    cursor: pointer;\n}\n\n.control-button-dark > .MuiSvgIcon-root {\n    color: white;\n    font-size: 1.3rem;\n}\n\n.control-button-dark:hover > .MuiSvgIcon-root {\n    color: azure;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
